/**
 * API Helper utilities for handling paginated responses
 */

/**
 * Extract items array from API response
 * Handles both paginated responses ({ items: [], total: X }) and direct arrays
 * @param {object|array} response - API response data
 * @returns {array} - The items array
 */
export function getItems(response) {
  if (!response) return [];
  // If it's already an array, return as-is
  if (Array.isArray(response)) return response;
  // If it has an items property (paginated response), return items
  if (response.items && Array.isArray(response.items)) return response.items;
  // Fallback to empty array
  return [];
}

/**
 * Get pagination metadata from API response
 * @param {object} response - API response data
 * @returns {object} - Pagination metadata { total, page, limit, pages, hasNext, hasPrev }
 */
export function getPagination(response) {
  if (!response || Array.isArray(response)) {
    return { total: 0, page: 1, limit: 50, pages: 0, hasNext: false, hasPrev: false };
  }
  return {
    total: response.total || 0,
    page: response.page || 1,
    limit: response.limit || 50,
    pages: response.pages || 0,
    hasNext: response.hasNext || false,
    hasPrev: response.hasPrev || false,
  };
}
